import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import { googleMapsApiKey } from '../lib/config';
import PublicLayout from "../components/Layout/PublicLayout";
import PrivateLayout from "../components/Layout/PrivateLayout";
import RequireAuth from "../auth/RequireAuth";
import { PowerSyncProvider } from '../auth/PowerSyncContext';

import Home from "../pages/Home";
import Login from "../pages/Login";
import Dashboard from "../components/Modules/Dashboard";
import PetrolBunk from "../components/Modules/PetrolBunk/PetrolBunkList";
import PetrolBunkAdd from "../components/Modules/PetrolBunk/PetrolBunkAdd";
import PetrolBunkEdit from "../components/Modules/PetrolBunk/PetrolBunkEdit";
import PetrolBunkDetail from "../components/Modules/PetrolBunk/PetrolBunkDetail";
import Camera from "../components/Modules/Camera/Camera";
import User from "../components/Modules/User/User";
import Vehicle from "../components/Modules/Vehicle/Vehicle";
import VehicleDetails from "../components/Modules/Vehicle/VehicleDetails";
import FuelRate from "../components/Modules/FuelRate/FuelRate";

import UnauthorizedPage from "../pages/UnauthorizedPage";
import Page404 from "../pages/Page404";

const Router = () => (
  <BrowserRouter>
    <Routes>

      <Route path="/login" element={<Login />} />

      {/* Public */}
      {/*<Route element={<PublicLayout />}>
        <Route path="/home" element={<Home />} />
      </Route> */}

      {/* Protected */}
      <Route element={<RequireAuth />}>
        <Route element={<PrivateLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/bunk" element={<PetrolBunk />} />
          <Route path="/bunk/add" element={<LoadScript googleMapsApiKey={googleMapsApiKey} libraries={["places"]}>
                                            <PetrolBunkAdd />
                                          </LoadScript>} />
          <Route path="/bunk/edit/:recordId" element={<LoadScript googleMapsApiKey={googleMapsApiKey} libraries={["places"]}>
                                            <PetrolBunkEdit />
                                          </LoadScript>} />                                
          <Route path="/bunk/view/:recordId" element={<PowerSyncProvider><PetrolBunkDetail /></PowerSyncProvider>} />
          <Route path="/bunkdetail" element={<PowerSyncProvider><PetrolBunkDetail /></PowerSyncProvider>} />
          <Route path="/camera" element={<Camera />} />
          <Route path="/users" element={<User />} />
          <Route path="/vehicle" element={<Vehicle />} />
          <Route path="/vehicle/detail" element={<VehicleDetails />} />
          <Route path="/fuelrate" element={<FuelRate />} />

          <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Route>
      </Route>

      <Route element={<PrivateLayout />}>
          <Route path="*" element={<Page404 />} />
      </Route>   

    </Routes>
  </BrowserRouter>
);

export default Router;
